<template>
  <div
    class="dialog-note tw:type-advice tw:flex tw:items-start tw:gap-2.75 tw:py-3.25 tw:px-3.5 tw:rounded-(--radius-note)"
    :data-tone="tone"
  >
    <span class="dialog-note__icon tw:flex-none tw:mt-0.25"
      ><AppIcon size="action" :name="icon"
    /></span>
    <div><slot /></div>
  </div>
</template>
<script setup>
// 1. Import necessary components
import AppIcon from './AppIcon.vue';
// 2. Use
defineProps({
  tone: {
    type: String,
    default: 'info',
    validator: (value) => ['info', 'warning', 'danger'].includes(value),
  },
  icon: { type: String, required: true },
});
// 3. Define a reactive variable
// 4. Define methods or computed properties if needed
// 5. VueJS Hooks
</script>
<style scoped>
/* The dialog grid adds a 1rem gap, so the margins bring the design's 12px above and 14px below the note. */
.dialog-note {
  margin-block: -4px -2px;
}
.dialog-note > div {
  min-width: 0;
  overflow-wrap: anywhere;
}
/* The design's inline icon sits on the text baseline, which makes a one-line note taller. */
.dialog-note__icon svg {
  display: inline;
  vertical-align: baseline;
}
.dialog-note[data-tone='info'] {
  background: var(--primary);
  color: var(--primary-foreground);
}
.dialog-note[data-tone='warning'] {
  background: var(--warning-soft);
  color: var(--warning-ink);
}
.dialog-note[data-tone='danger'] {
  background: var(--destructive-soft);
  color: var(--destructive-ink);
}
</style>
